/**
 * Algolia module exports.
 *
 * This is the public API for the Algolia integration.
 */

// Configuration
// Analytics
export {
  createAnalyticsContext,
  getAlgoliaUserToken,
  setAlgoliaUserToken,
  trackAddToCart,
  trackProductClick,
  trackProductConversion,
  trackPurchase,
} from './analytics';
export type { SearchAnalyticsContext } from './analytics';
export {
  getAlgoliaDebugEntries,
  runWithAlgoliaDebugCollection,
  type AlgoliaDebugEntry,
  type AlgoliaDebugPhase,
} from './debugLog';
// Search (via BFF - use these everywhere)
export {
  searchByProductType,
  searchProducts,
  searchStraps,
  type SearchByTypeParams,
  type SearchProductType,
} from './bffSearch';
// Cached facets (ISR)
export {
  getCachedFacets,
  getCachedFacetsDeduped,
  resolveAlgoliaLocaleCode,
  type FacetProductType,
} from './cachedFacets';
// Client
export {
  getAlgoliaClient,
  getProductIndexName,
  resetClients,
  warmupAlgoliaConnection,
} from './client';
// Color mappings for filter swatches
export {
  BREITLING_COLLECTION_IMAGES,
  CASE_COLOR_MAPPING,
  CASE_SVG_MAPPING,
  DIAL_COLOR_MAPPING,
  GALLET_COLLECTION_IMAGES,
  getCaseColor,
  getCaseSvg,
  getCollectionImages,
  getColorMapping,
  getDialColor,
  getStrapColor,
  isCollectionFacet,
  isSwatchFacet,
  STRAP_COLOR_MAPPING,
} from './colorMappings';
export { ALGOLIA_CONFIG, getLocaleCode, getLocaleCodeCandidates } from './config';
// Facets
export {
  EYEWEAR_FACETS,
  FACET_DISPLAY_NAMES,
  FACET_TO_URL_PARAM,
  getBaseFacetName,
  getEyewearFacets,
  getStrapFacets,
  getWatchFacets,
  STRAP_FACETS,
  URL_PARAM_TO_FACET,
  WATCH_FACETS,
} from './facets';
// Facet value utilities (for ID-based filtering)
export {
  extractFacetId,
  extractFacetLabel,
  facetValueMatchesId,
  findFacetValueById,
  getAlgoliaFilterValue,
  getLabelForId,
  parseFacetValue,
} from './facetValues';
// Filters
export {
  buildBaseFilterString,
  buildCollectionFilter,
  buildFilterString,
  buildSkuFilter,
  filterReleasedOrDraftProducts,
  ProductConfigurationFilterType,
} from './filters';
export type { BuildFilterOptions, ProductType } from './filters';
// Server-compatible param parsing
export {
  AND_FILTERS,
  AND_SEPARATOR,
  OR_FILTERS,
  OR_SEPARATOR,
  parseSearchParams,
  hasListingChrome,
} from './params';
// Internal search (direct Algolia - ONLY for API routes)
export {
  ALGOLIA_FETCH_FAILED,
  checkProductActivation,
  filterEnabledBundleVariations,
  getProductById,
  getProductsByIds,
  getReleasedProductsByIds,
  searchProductsInternal,
} from './search';
export type { AlgoliaFetchFailed } from './search';
// Store data
export {
  fetchStores,
  fetchStoresInternal,
  type StoreHit,
  type StoreSearchParams,
  type StoreSearchResult,
} from './stores';
export { isStrapHit, isWatchHit } from './types';
// Types
export type {
  AlgoliaEventType,
  ClickEventData,
  ConversionEventData,
  FacetResults,
  FilterState,
  HighlightResult,
  ProductHit,
  SearchParams,
  SearchResult,
  SortOption,
  StrapHit,
  WatchHit,
} from './types';
